import { Action, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import { SettingsActions, SettingsState } from "@/components/settings/types";

export const actions: ActionTree<SettingsState, RootState> &
  Record<SettingsActions, Action<SettingsState, RootState>> = {};
